<template>
  <b-field>
    <b-dropdown
      aria-role="list"
      class="export-dropdown-menu"
      :disabled="disabled"
    >
      <button
        :class="[$style.dropdownButton, 'button']"
        slot="trigger"
        slot-scope="{ active }"
      >
        <span>Export</span>
        <b-icon
          class="dropdown-arrow-icon-down"
          type="is-black"
          :icon="active ? 'chevron-up' : 'chevron-down'"
          size="is-small"
        ></b-icon>
      </button>
      <b-dropdown-item
        v-for="(exportType, exportTypeIndex) in dirtyExportType"
        :key="exportTypeIndex"
        aria-role="listitem"
        :class="$style.dropdownItem"
        @click="handleExport(exportType)"
      >
        {{ exportType }}
      </b-dropdown-item>
    </b-dropdown>
  </b-field>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep as _cloneDeep } from 'lodash';
import { reportExportType } from '@/store/types/general.types';

@Component({ components: {} })
export default class ProjectExportExportButton extends Vue {
  @Prop({ default: false })
  public disabled!: boolean;
  @Prop({ default: false })
  public isProjectDashboard!: boolean;
  public dirtyExportType: string[] = [];

  public mounted() {
    this.dirtyExportType = _cloneDeep(reportExportType);
    /** project dashboard export should have 'CSV' & 'XLSX' formats only as option */
    if (this.isProjectDashboard) {
      this.dirtyExportType.splice(0, 2);
    } else {
      /** export report should have 'PDF' & 'DOCX' formats only as option */
      this.dirtyExportType.splice(2, 4);
    }
  }

  public handleExport(exportType: string) {
    this.$emit('handleExport', exportType);
  }
}
</script>
<style lang="scss" module>
.dropdownButton {
  background: #fbfbfb;
  width: 100%;
  justify-content: space-between;
  padding: 11px 12px 11px 12px;
  height: 40px;
  span:first-child {
    color: #444f51;
    font-weight: 500;
  }
}
.dropdownItem {
  padding-top: 10px;
  padding-left: 12px;
  padding-bottom: 10px;
  font-weight: 400;
  color: #444f51 !important;
  border-bottom: 0.5px solid #dbdbdb;
}
.dropdownItem:last-child {
  border-bottom: unset;
}
</style>
